<template>
    <div class="c-welcome">
        <router-link class="c-welcome__logo" tag="h1" :to="{name: 'home'}">
          <img src="@/assets/logos/logo.svg" :alt="$t('common.app_name')" :title="$t('common.app_name')">
        </router-link>
        <h2 class="c-welcome__title">{{ title || $t('landing.title') }}</h2>
        <h3 class="c-welcome__desc">{{ subtitle || $t('landing.subtitle') }}</h3>
    </div>
</template>

<style lang="scss">
  .c-welcome__logo {
    cursor: pointer;
  }
</style>

<script>
export default {
  name: 'WelcomeSlogan',
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
}
</script>
